<template>
  <div class="multi-camera-slot">
    <div
      v-for="(row, rowIndex) in cameraRows"
      :key="rowIndex"
      class="multi-camera-row"
      :style="rowStyle(row)"
    >
      <div
        v-for="camera in row"
        :key="camera.id"
        class="multi-camera-cell"
        :style="cellStyle(row)"
      >
        <camera-widget-v2
          :camera-id="camera.camera_id || camera.id"
          :camera-proxy-id="camera.camera_proxy_id || camera.id_camera_proxy"
          :camera-type="camera.camera_type"
          :host="slotData.host"
          :date-range="{}"
          :tab-info="tabInfo"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import CameraWidgetV2 from "../../widgets/CameraWidgetV2.vue";

export default {
  name: "MultiCameraSlot",
  components: { CameraWidgetV2 },
  props: {
    slotData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const columns = computed(() => {
      const count = props.slotData.cameras.length;
      if (count <= 1) return 1;
      if (count <= 4) return 2;
      if (count <= 9) return 3;
      if (count <= 16) return 4;
      if (count <= 25) return 5;
      return 6;
    });

    const totalRows = computed(() => {
      return Math.ceil(props.slotData.cameras.length / columns.value);
    });

    const cameraRows = computed(() => {
      const rows = [];
      const cameras = props.slotData.cameras;
      for (let i = 0; i < cameras.length; i += columns.value) {
        rows.push(cameras.slice(i, i + columns.value));
      }
      return rows;
    });

    const tabInfo = computed(() => ({
      id: "standalone",
      type: "standalone",
    }));

    const rowStyle = () => ({
      display: "flex",
      justifyContent: "center",
      flex: "1 1 0",
      minHeight: 0,
      gap: "2px",
    });

    const cellStyle = () => {
      //const widthPercent = 100 / columns.value;
      return {
        //width: `calc(${widthPercent}% - 2px)`,
        flex: "1 1 0px",

        minWidth: 0, // Importante para evitar desbordamientos en flexbox
        minHeight: 0,
        overflow: "hidden",
        position: "relative",
      };
    };

    return {
      columns,
      totalRows,
      cameraRows,
      tabInfo,
      rowStyle,
      cellStyle,
    };
  },
};
</script>

<style scoped>
.multi-camera-slot {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 2px;
  background-color: #000;
}
</style>
